import { apiUrl } from "../../config/base.js";
import axios from 'axios';

export default {
	store(user) {
		return axios.post(apiUrl + '/waiting-list', { user: user });
	}
}

